export default "__VITE_ASSET__BEk8bHz8__"